module.exports = __webpack_public_path__ + "static/img/activity_zjs_bg.f95bb7c9.png";